import Forget from '../../../statics/illustrations/forgot.svg'
import Formchange from './formChange'

const Changepassword = () => {
  return (
    <div className="container">
      <div className="gs:grid">
          <div className="c-change-left col-12 lg:col-5">
            <Formchange/>
          </div>
          <div className="c-change-right col-12 lg:col-7">
            <h1 className="c-change-right__title">You are almost back in</h1>
            <img className="c-change-right__img"src={Forget} alt="forget" />
          </div>
      </div>
    </div>
  )
}

export default Changepassword